import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Paper,
  Typography,
  Divider,
  Button,
  Container,
  CircularProgress,
  Box
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const EmpresaDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [empresa, setEmpresa] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/api/empresas/${id}`);
        setEmpresa(response.data);
        setError('');
      } catch (err) {
        setError('No se pudo cargar la empresa.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpresa();
  }, [id]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (!empresa) {
    return null;
  }

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 3, mt: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h5" gutterBottom>
            Detalle de la Empresa: {empresa.nombre}
          </Typography>
          <Box>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<EditIcon />}
              onClick={() => navigate(`/empresas/editar/${id}`)}
            >
              Editar
            </Button>
          </Box>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="body1"><strong>ID:</strong> {empresa.id}</Typography>
        <Typography variant="body1"><strong>RFC:</strong> {empresa.rfc || 'N/A'}</Typography>
        <Typography variant="body1"><strong>Dirección Fiscal:</strong> {empresa.direccion_fiscal || 'N/A'}</Typography>
        <Typography variant="body1"><strong>Teléfono:</strong> {empresa.telefono || 'N/A'}</Typography>
        <Typography variant="body1"><strong>Email Compras:</strong> {empresa.email_compras || 'N/A'}</Typography>
        <Divider sx={{ my: 2 }} />
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/empresas')}
          sx={{ mt: 2 }}
        >
          Volver a la Lista
        </Button>
      </Paper>
    </Container>
  );
};

export default EmpresaDetail;
